



























import {Vue, Component} from "vue-property-decorator"
import AuthApi from "@/api/AuthApi";

@Component({})
export default class Login extends Vue {
  public isLoaded: boolean = false
  public login: string = ''
  public pass: string = ''

  async submitLogin(){
    if (this.login != '' && this.pass != ''){
      try {
        this.isLoaded = true
        await AuthApi.login(this.login, this.pass)
        .then(res => {
          if (res.data.status === true){
            localStorage.setItem('session', JSON.stringify(res.data))
            this.$router.push('/')
          } else {
            console.log(res.data)
            alert(res.data.message)
            this.isLoaded = false
          }
        })
        .catch(err => {
          console.log(err)
          alert(err.message)
          this.isLoaded = false
        })
      } catch (e) {
        console.log('Err: ' + e)
        this.isLoaded = false
      }
    } else {
      alert('Проверьте правильно')
    }
  }

}

